import { useMemo } from 'react';
import { useGetTeacherAssignmentsCoursesQuery } from '@/entities/TeacherAssignment';
import { SelectOption } from '@/shared/ui/Fields';

export const useFilterOptions = (courseType: string, courseId: string) => {
  const { data: coursesData, isLoading, isFetching } = useGetTeacherAssignmentsCoursesQuery();

  const filteredCourses = useMemo(() => {
    if (!coursesData?.courses || !courseType) return [];
    return coursesData.courses.filter((course) => course.type === courseType);
  }, [coursesData, courseType]);

  const courseOptions: SelectOption[] = useMemo(
    () => filteredCourses.map((course) => ({ value: String(course.id), label: course.title })),
    [filteredCourses],
  );

  const selectedCourse = useMemo(
    () => filteredCourses.find((c) => String(c.id) === courseId),
    [filteredCourses, courseId],
  );

  const intakeOptions: SelectOption[] = useMemo(
    () =>
      selectedCourse?.intakes.map((intake) => ({
        value: String(intake.id),
        label: intake.title,
      })) || [],
    [selectedCourse],
  );

  const termOptions: SelectOption[] = useMemo(
    () =>
      selectedCourse?.termNumbers.map((num) => ({
        value: String(num),
        label: `# ${num}`,
      })) || [],
    [selectedCourse],
  );

  const groupOptions: SelectOption[] = useMemo(
    () =>
      selectedCourse?.groupNumbers.map((num) => ({
        value: String(num),
        label: `Group ${num}`,
      })) || [],
    [selectedCourse],
  );

  return {
    courseOptions,
    intakeOptions,
    termOptions,
    groupOptions,
    selectedCourse,
    coursesData,
    isLoading: isLoading || isFetching,
  };
};
